import { useEffect } from 'react';

/**
 * Hook personalizado para manejar el evento de la tecla Escape
 * @param {Function} callback - Función a ejecutar cuando se presiona Escape
 * @param {boolean} active - Si el hook está activo o no (opcional)
 */
const useEscapeKey = (callback, active = true) => {
  useEffect(() => {
    if (!active) return;
    
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        callback();
      }
    };
    
    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [callback, active]);
};

export default useEscapeKey; 